import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { CONTENTFUL_IS_PREVIEW } from 'config/env';
import { Category } from '@novaheal/types';
import { axios } from 'utils/axios';

export const getAllCategories = async (): Promise<(Category | null)[]> => {
  const { data: folders } = await axios.get<(Category | null)[]>(
    `/gql/folders?preview=${CONTENTFUL_IS_PREVIEW}`
  );

  return folders;
};

export const useCategories = (): UseQueryResult<Category[], unknown> => {
  return useQuery({
    queryKey: ['parentFolders'],
    queryFn: getAllCategories,
  });
};
